module.exports = __webpack_public_path__ + "img/MDMqt1.fcab07e9.jpg";